import { pageSize } from "./../../Components/Common/styles/table";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type PaginationProps = {
  page: number;
  pageSize: number;
};

export interface ParticipantsState {
  loading: boolean;
  participantsData: any[];
  totalParticipants: number;
  paginationModel: PaginationProps;
  toggleLoader: boolean;
  sortOrder: string;
  sortColumn: string;
  siteIds: string[];
  status: string;
  isLocked: string;
  searchText: string;
  searchType: string;
  isOptout: string;
  flagType: string;
  timeline: string;
  startDate: string;
  endDate: string;
  type: string;
}

const initialState: ParticipantsState = {
  loading: true,
  toggleLoader: false,
  paginationModel: {
    page: 0,
    pageSize: pageSize,
  },
  participantsData: [],
  totalParticipants: 0,
  sortOrder: "",
  sortColumn: "",
  siteIds: [],
  status: "",
  isLocked: "",
  searchText: "",
  searchType: "mrn",
  isOptout: "",
  flagType: "",
  timeline: "",
  startDate: "",
  endDate: "",
  type: "active",
};

export const participantsSlice = createSlice({
  name: "participants",
  initialState: initialState,
  reducers: {
    setParticipantsLoader: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setParticipantsDetails: (state, action: PayloadAction<any>) => {
      state.participantsData = action.payload;
    },
    setParticipantsCount: (state, action: PayloadAction<number>) => {
      state.totalParticipants = action.payload;
    },
    setParticipantsPage: (state, action: PayloadAction<PaginationProps>) => {
      state.paginationModel = action.payload;
    },

    setPatientSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setPatientSearchType: (state, action: PayloadAction<string>) => {
      state.searchType = action.payload;
    },

    setParticipantToggle: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    setParticipantSort: (
      state,
      action: PayloadAction<{ column: string; order: string }>
    ) => {
      state.sortColumn = action.payload.column;
      state.sortOrder = action.payload.order;
    },
    setParticipantFilter: (
      state,
      action: PayloadAction<{
        // siteIds: string[];
        isOptout: string;
        flagType: string;
        timeline: string;
        startDate: string;
        endDate: string;
      }>
    ) => {
      state.paginationModel.page = 0;
      // state.siteIds = action.payload.siteIds;
      state.isOptout = action.payload.isOptout;
      state.flagType = action.payload.flagType;
      state.timeline = action.payload.timeline;
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    setPatientsType: (state, action: PayloadAction<string>) => {
      state.searchText = "";
      state.sortColumn = "";
      state.sortOrder = "";
      state.isOptout = "";
      state.flagType = "";
      state.timeline = "";
      state.startDate = "";
      state.endDate = "";
      state.searchType = "mrn";
      state.paginationModel.page = 0;
      state.type = action.payload;
    },
    setTabType: (state, action: PayloadAction<string>) => {
      state.searchText = "";
      state.sortColumn = "";
      state.sortOrder = "";
      state.searchType = "mrn";
      state.paginationModel.page = 0;
      state.type = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setParticipantsLoader,
  setParticipantsDetails,
  setParticipantsCount,
  setParticipantsPage,
  setPatientSearchText,
  setPatientSearchType,
  setParticipantToggle,
  setParticipantSort,
  setParticipantFilter,
  setPatientsType,
  setTabType,
  reset,
} = participantsSlice.actions;

export default participantsSlice.reducer;
